var map;

function checkMap(zoom) {
  if(zoom===undefined){
    zoom=4
  }
  if (map === undefined) {
    map = new AMap.Map('china', {
      zoom: zoom
    })
  }
}

/**
 * 初始化区域数据
 * @param regionCode
 * @param callback
 * @param zoom
 */
export function initDistrict(regionCode, callback,zoom) {
  checkMap(zoom)
  if (regionCode === undefined) {
    regionCode = 100000
  }
  AMapUI.loadUI(['geo/DistrictExplorer'], function (DistrictExplorer) {
    //启动页面
    initPage(DistrictExplorer, regionCode, callback)
  })
}

function initPage(DistrictExplorer, regionCode, callback) {
  checkMap()
  var districtExplorer = new DistrictExplorer({
    eventSupport: true, //打开事件支持
    map: map //关联的地图实例
  })
  loadAreaNode(districtExplorer,regionCode, callback)
}

/**
 * 加载指定区域数据
 * @param districtExplorer
 * @param regionCode
 * @param callback
 */
export function loadAreaNode(districtExplorer, regionCode, callback) {
  if (districtExplorer === undefined || districtExplorer === null) {
    console.log('区域选择器未初始化')
    return
  }
  let result = {
    districtExplorer: districtExplorer
  }
  districtExplorer.loadAreaNode(regionCode, function (error, areaNode) {
    if (error) {
      console.error(error);
      callback(result)
      return;
    }
    const adcode = areaNode.getAdcode();
    const geoJSON = areaNode.getSubFeatures(); // 获取 geoJSON 数据
    const name = areaNode.getName();
    if (!geoJSON ) {
      return;
    }
    const mapData = {
      type: 'FeatureCollection',
      features: geoJSON
    };
    result.mapData = mapData
    result.regionName = name
    result.regionCode = adcode
    callback(result)
  })
}

function renderAreaNode(districtExplorer, areaNode, colors) {
  checkMap()
  //清除已有的绘制内容
  districtExplorer.clearFeaturePolygons();
  //just some colors
  if (colors === undefined) {
    colors = ["#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", "#0099c6", "#dd4477", "#66aa00"];
  }
  //绘制子级区划
  districtExplorer.renderSubFeatures(areaNode, function (feature, i) {
    var fillColor = colors[i % colors.length];
    var strokeColor = colors[colors.length - 1 - i % colors.length];
    return {
      cursor: 'default',
      bubble: true,
      strokeColor: strokeColor, //线颜色
      strokeOpacity: 1, //线透明度
      strokeWeight: 1, //线宽
      fillColor: fillColor, //填充色
      fillOpacity: 0.35, //填充透明度
    };
  });
  //绘制父级区划，仅用黑色描边
  districtExplorer.renderParentFeature(areaNode, {
    cursor: 'default',
    bubble: true,
    strokeColor: 'black', //线颜色
    fillColor: null,
    strokeWeight: 3, //线宽
  });

  //绘制父级区划，仅用黑色描边
  districtExplorer.renderParentFeature(areaNode, {
    cursor: 'default',
    bubble: true,
    strokeColor: 'black', //线颜色
    fillColor: null,
    strokeWeight: 3, //线宽
  });
  //更新地图视野以适合区划面
  map.setFitView(districtExplorer.getAllFeaturePolygons());
}
